export default __webpack_public_path__ + "static/media/domain.40f1c174.png";